import request from '@/utils/request'

export function cart(data) {
    return request({
        url: '/cart/cart',
        method: 'post',
        data: data
    })
}

export function getUser(data) {
    return request({
        url: '/getUser',
        method: 'post',
        data: data
    })
}




// WEBPACK FOOTER //
// ./src/api/app.js